import { type UseQueryResult, useQuery } from 'react-query';
import { ParticipantLogInAndSecurityService } from '../../services/wealthlane-identity-services';
import { TwoFactorConfigurationService } from '../../services/wealthlane-identity-services/services/TwoFactorConfigurationService';

const useGetTwoFactorAuthenticationOptions = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
    label: string;
    value: string | number;
  }>
  | undefined,
  unknown
> => {
  const twoFactorAuthenticationOptions = useQuery(
    ['getTwoFactorAuthenticationOptions'],
    async () => {
      return await handleRequest(
        // ParticipantLogInAndSecurityService.getApiIdentityApiAppParticipantLogInAndSecurityTwoFactorAuthenticationOptions()
        TwoFactorConfigurationService.getApiIdentityApiTwoFactorConfigurationTwoFactorAuthenticationOptions()

      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.securityOption ?? '',
            value: item.optionId ?? '',
          };
        });
      },
    }
  );

  return twoFactorAuthenticationOptions;
};

export default useGetTwoFactorAuthenticationOptions;
